import { render, staticRenderFns } from "./PB-Header.vue?vue&type=template&id=aa74734a&scoped=true&"
import script from "./PB-Header.vue?vue&type=script&lang=js&"
export * from "./PB-Header.vue?vue&type=script&lang=js&"
import style0 from "./PB-Header.vue?vue&type=style&index=0&id=aa74734a&prod&scoped=true&lang=css&"
import style1 from "./PB-Header.vue?vue&type=style&index=1&id=aa74734a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74734a",
  null
  
)

export default component.exports